import React, { useEffect } from "react";
import { Box, Typography, Container } from "@mui/material";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import { useNavigate } from "react-router-dom";

export default function MobileVerifiedSuccess() {
  const navigate = useNavigate();

  // 🔁 Auto navigate after delay
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/registration/lowkyc/profiledetails");
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <Header />

      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#f5f7f6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              bgcolor: "white",
              borderRadius: 3,
              display: "flex",
              overflow: "hidden",
              boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
              minHeight: 420,
            }}
          >
            {/* Left Panel */}
            <Box
              sx={{
                width: "40%",
                bgcolor: "#0aa34f",
                p: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src="/Assets/image.png" style={{ maxWidth: "100%" }} />
            </Box>

            {/* Right Content */}
            <Box
              sx={{
                width: "60%",
                p: 6,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  bgcolor: "#7cb342",
                  mx: "auto",
                  mb: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 42,
                  color: "white",
                }}
              >
                ✓
              </Box>

              <Typography variant="h4" color="#16a34a" fontWeight={600}>
                Successfully Mobile Verified
              </Typography>

              <Typography mt={2} color="text.secondary">
                Redirecting to profile details...
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>

      <Footer />
    </>
  );
}
